module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('multi-select', {
    attrs: {
      "value": _vm.value,
      "label": _vm.label,
      "filter": _vm.filter,
      "url": "cities",
      "placeholder": "Wähle einen Ort aus"
    },
    on: {
      "input": _vm.update
    }
  }, [_c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v("\n        Keine Orte gefunden\n    ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-55dc4f78","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/city-select.vue
// module id = 103
// module chunks = 0 1